//
// Module for showing and hiding html elements which were hidden using the hide-if tag helper attribute.
//
rs.module("common/visibility",

    ["ui/framework/sass-exports"],
    
    function (sassExports) {

        // get the CSS class used for showing and hiding elements
        var cssClass = sassExports.data("hiddenCssClass");

        // Show the elements
        function show(elements) {
            $(elements).removeClass(cssClass);
        }

        // Hide the elements
        function hide(elements) {
            $(elements).addClass(cssClass);
        }

        // Set the visibility of the elements
        function setVisible(elements, visible) {
            visible ? show(elements) : hide(elements);
        }

        var exports = {
            hide: hide,
            show: show,
            setVisible: setVisible
        };

        return exports;
    }
);
